import { FunctionComponent } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import '@dw/dayjs';

import {
  AppSettingsContextProvider,
  HttpClientContextProvider,
  SnackbarContextProvider,
  ConfirmContextProvider,
  SessionContextProvider,
  ScreenSizeContextProvider
} from '@dw/contexts';

import { QUERY_CLIENT_STALE_TIME } from '@dw/constants';

import { AppTheme } from './theme/App.theme';
import { AppRouter } from './App.router';

const QUERY_CLIENT = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: QUERY_CLIENT_STALE_TIME
    },
  }
});

export const App: FunctionComponent = () => {
  return (
    <AppTheme>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-nz'>
        <SnackbarContextProvider>
          <QueryClientProvider client={QUERY_CLIENT}>
            <AppSettingsContextProvider>
              <SessionContextProvider>
                <HttpClientContextProvider>
                  <ScreenSizeContextProvider>
                    <ConfirmContextProvider>

                      <AppRouter />

                    </ConfirmContextProvider>
                  </ScreenSizeContextProvider>
                </HttpClientContextProvider>
              </SessionContextProvider>
            </AppSettingsContextProvider>
          </QueryClientProvider>
        </SnackbarContextProvider>
      </LocalizationProvider>
    </AppTheme>
  );
}
